export default "__VITE_ASSET__0df46a5f__"